module.exports = __webpack_public_path__ + "static/media/ending-stock.09648356.png";